<template>
  <BaseModal :title="$t('Tender members')" :subtitle="offer.tender.name">
    <div class="spacey-12">
      <InviteTeammate :offer="offer" @update-members="updateOffer" />
      <Spinner v-if="isLoading" />
      <div v-else class="base-table spacey-12">
        <div class="table-header settings-tender-table-columns">
          <div class="text-sm grey-500">
            {{ $t('Already in tender') }}
          </div>
          <div class="text-sm grey-500">
            {{ $t('Position') }}
          </div>
          <div class="text-sm grey-500 vertical-centering spacex-4">
            <span>{{ $t('Role') }}</span>
            <RolesTooltip />
          </div>
        </div>
        <TenderMemberRow
          v-for="member in offer.contractor_responsible_users"
          :key="member.user_id"
          :member="member"
          :offer="offer"
          @update-members="updateOffer"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import BaseModal from '@/components/ui/BaseModal';
  import RolesTooltip from '@/components/common/Tooltips/RolesTooltip';
  import TenderMemberRow from '@/containers/top-menu/header/tender/contractor/TenderMemberRow';
  import InviteTeammate from '@/containers/top-menu/header/tender/contractor/InviteTeammate';
  import Spinner from 'vue-simple-spinner';

  export default {
    name: 'TenderMembersModal',
    components: {
      InviteTeammate,
      BaseModal,
      RolesTooltip,
      TenderMemberRow,
      Spinner,
    },
    props: {
      context: Object,
    },
    data() {
      return {
        isLoading: false,
      };
    },
    methods: {
      ...mapActions({
        loadIncomingTenderInfo: 'incomingTender/loadIncomingTenderInfo',
      }),
      async updateOffer() {
        this.isLoading = true;
        await this.loadIncomingTenderInfo(this.offer.id);
        this.isLoading = false;
      },
    },
    computed: {
      ...mapState({
        offer: (state) => state.incomingTender.incomingTenderInfo,
      }),
    },
  };
</script>
